import React, { useState, useEffect } from "react";
import Navbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footers/Footer";
import axios from "axios";
import Swal from "sweetalert2";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import BASE_URL from "components/BaseUrl/apiConfig";

function SettingsForAdmin() {
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchApiKey = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BASE_URL}/api/Expense/getApiverifykey`
        );
        setApiKey(response.data.msg); // Assuming response.data.msg contains the API key
      } catch (error) {
        console.error("Error fetching API Key:", error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to fetch API Key. Please try again later.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchApiKey();
  }, []); // Empty dependency array ensures this effect runs only once on component mount

  const handleUpdateApiKey = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: "<h2>Warning!</h2>",
      html: `
      <h3>Changing the API key will affect the email verification functionality across the entire website.</h3>
      <br>
      <h2>Are you sure you want to proceed with updating the Email Verification API Key?</h2>
    `,
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, keep the current key",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BASE_URL}/api/Expense/AddEmailAPIkey?email=${apiKey}`
        );
        console.log("API Key updated successfully:", response.data);

        // Show success message using SweetAlert2
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "API Key updated successfully.",
        });

        // Optionally reset input field or perform other actions
        // setApiKey("");
      } catch (error) {
        console.error("Error updating API Key:", error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to update API Key. Please try again later.",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="cust-div">
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto p-4">
          <div className="flex flex-wrap items-center mb-4">
            <h1 className="text-2xl font-bold">SETTINGS</h1>
          </div>

          <div className="flex items-center mb-4">
            <div className="flex flex-col w-full">
              <label
                htmlFor="apiKey"
                className="mb-2 text-sm font-medium text-gray-700"
              >
                Verify Email API Key
              </label>
              <div className="flex">
                <input
                  type="text"
                  id="apiKey"
                  className="form-control custom-height w-full mr-4"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                />
                <button
                  className="px-4 py-2 text-white bg-blue-500 rounded-md text-xs md:text-base font-bold uppercase mb-1 shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 custom-button"
                  onClick={handleUpdateApiKey}
                  disabled={loading || !apiKey}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <hr className="mb-4  mx-auto px-4 border-b-1 border-blueGray-200" />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SettingsForAdmin;
